import { createApiClient } from './http-client';
const TOKEN_KEY = 'jv_token';
const EXPIRES_KEY = 'jv_expires';
const runtimeConfig = window;
const viteEnv = import.meta.env;
const API_URL = runtimeConfig.JUSTVUE_API_URL || viteEnv?.VITE_API_URL || '';
export class AuthService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this.api = createApiClient({
            baseUrl,
            getToken: () => this.getToken(),
            onUnauthorized: () => this.logout(),
        });
    }
    getToken() {
        return localStorage.getItem(TOKEN_KEY);
    }
    isAuthenticated() {
        const token = this.getToken();
        if (!token)
            return false;
        const expiresAt = localStorage.getItem(EXPIRES_KEY);
        if (expiresAt && new Date(expiresAt) <= new Date()) {
            this.logout();
            return false;
        }
        return true;
    }
    async login(email, password, tenantId) {
        const body = { email, password, tenantId };
        const response = await fetch(`${this.baseUrl}/api/auth/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            const err = await response.json().catch(() => ({}));
            throw new Error(err.message || 'Login failed');
        }
        const data = await response.json();
        localStorage.setItem(TOKEN_KEY, data.accessToken);
        localStorage.setItem(EXPIRES_KEY, data.expiresAt);
        return data;
    }
    async getMe() {
        return this.api.get('/api/auth/me');
    }
    logout() {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(EXPIRES_KEY);
    }
    getState() {
        return {
            token: this.getToken() || '',
            expiresAt: localStorage.getItem(EXPIRES_KEY) || '',
            user: null,
        };
    }
}
export const authService = new AuthService(API_URL);
